





















import { Component, Vue, Prop } from 'vue-property-decorator';
import UserNotificationForm from '@/components/forms/UserNotificationForm.vue';
import { Route, RawLocation } from 'vue-router';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
]);

@Component({
    components: {
        UserNotificationForm
    }
})
export default class NotificationEdit extends Vue {
    public $refs!: {
        userNotificationForm: UserNotificationForm
    };

    @Prop() public id!: string | number;
    public beforeRouteUpdate(
        to: Route, from: Route, next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) {
            this.$refs.userNotificationForm.updateForm();
            next();
    }
}
